import React from 'react';
import PropTypes from 'prop-types';
import { efesBorder } from '../../theme';

const User = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 16">
    <path
      id="Path_2089"
      data-name="Path 2089"
      d="M9.8-4.5C8.9-4.5,8.472-4,7-4s-1.9-.5-2.8-.5A4.2,4.2,0,0,0,0-.3V.5A1.5,1.5,0,0,0,1.5,2h11A1.5,1.5,0,0,0,14,.5V-.3A4.2,4.2,0,0,0,9.8-4.5Zm2.7,5H1.5V-.3A2.7,2.7,0,0,1,4.2-3,12.235,12.235,0,0,0,7-2.5,12.117,12.117,0,0,0,9.8-3,2.7,2.7,0,0,1,12.5-.3ZM7-5a4.5,4.5,0,0,0,4.5-4.5A4.5,4.5,0,0,0,7-14,4.5,4.5,0,0,0,2.5-9.5,4.5,4.5,0,0,0,7-5Zm0-7.5a3,3,0,0,1,3,3,3,3,0,0,1-3,3,3,3,0,0,1-3-3A3,3,0,0,1,7-12.5Z"
      transform="translate(0 14)"
      fill={color}
    />
  </svg>
);

User.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

User.defaultProps = {
  width: 14,
  height: 16,
  color: efesBorder,
};

export default User;
